export default __webpack_public_path__ + "static/media/FootPlant.af53dba8.png";